var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAprilFool(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1040 1040",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.12 419.451c24.08-10.8 40.86-34.97 40.86-63.08 0-38.17-30.94-69.12-69.12-69.12-32.8 0-60.25 22.86-67.33 53.51-2.2-.18-4.41-.3-6.66-.3-43.62 0-78.98 35.36-78.98 78.98 0 43.62 35.36 78.98 78.98 78.98 2.24 0 4.46-.12 6.66-.3 7.08 30.65 34.52 53.51 67.33 53.51 38.17 0 69.12-30.94 69.12-69.12 0-28.1-16.78-52.27-40.86-63.08v.02zM704.76 419.451c-24.08-10.8-40.86-34.97-40.86-63.08 0-38.17 30.94-69.12 69.12-69.12 32.8 0 60.25 22.86 67.33 53.51 2.2-.18 4.41-.3 6.66-.3 43.62 0 78.98 35.36 78.98 78.98 0 43.62-35.36 78.98-78.98 78.98-2.24 0-4.46-.12-6.66-.3-7.08 30.65-34.52 53.51-67.33 53.51-38.17 0-69.12-30.94-69.12-69.12 0-28.1 16.78-52.27 40.86-63.08v.02z",
    fill: "#EF3A48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M469.29 884.442H310.86c-13.98-15.8-34.39-25.77-57.14-25.77-42.13 0-76.29 34.16-76.29 76.29v.14c.01 7.74 6.41 13.95 14.15 13.95h256.7c17.77 0 32.31-14.54 32.31-32.31v-21.02c0-6.24-5.05-11.29-11.29-11.29l-.01.01z",
    fill: "#F05360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.72 858.672c-42.13 0-76.29 34.16-76.29 76.29v.14c0 7.71 6.26 13.95 13.96 13.95h131.29l.02-17.69c0-16.94-4.18-32.91-11.57-46.92h-.28c-13.98-15.8-34.39-25.77-57.14-25.77h.01z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253.72 858.672c-42.13 0-76.29 34.16-76.29 76.29v.14c0 7.71 6.26 13.95 13.96 13.95h74.55",
    stroke: "#27B7BE",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M479.58 884.731l1 32.02c0 17.77-14.54 32.31-32.31 32.31H304.96",
    stroke: "#EF3A48",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M571.59 884.442h158.43c13.98-15.8 34.39-25.77 57.14-25.77 42.13 0 76.29 34.16 76.29 76.29v.14c-.01 7.74-6.41 13.95-14.15 13.95H592.6c-17.77 0-32.31-14.54-32.31-32.31v-21.02c0-6.24 5.05-11.29 11.29-11.29l.01.01z",
    fill: "#F05360"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M787.16 858.672c42.13 0 76.29 34.16 76.29 76.29v.14c0 7.71-6.26 13.95-13.96 13.95H718.2l-.02-17.69c0-16.94 4.18-32.91 11.57-46.92h.28c13.98-15.8 34.39-25.77 57.14-25.77h-.01z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M787.16 858.672c42.13 0 76.29 34.16 76.29 76.29v.14c0 7.71-6.26 13.95-13.96 13.95h-74.55",
    stroke: "#27B7BE",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M561.3 884.731l-1 32.02c0 17.77 14.54 32.31 32.31 32.31h143.31",
    stroke: "#EF3A48",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M194.47 708.681c-22.09 0-40-17.91-40-40v-50.24c0-33.08 26.92-60 60-60h93.51c22.09 0 40 17.91 40 40s-17.91 40-40 40h-73.51v30.24c0 22.09-17.91 40-40 40z",
    fill: "#2C848E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.47 668.681v-50.24c0-33.08 26.92-60 60-60h39.15",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M215.64 677.151H173.3c-27.78 0-50.3 22.52-50.3 50.3 0 27.78 22.52 50.3 50.3 50.3h42.34c27.78 0 50.3-22.52 50.3-50.3 0-27.78-22.52-50.3-50.3-50.3z",
    fill: "#FED425"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M235.48 648.611h-82c-10.024 0-18.15 8.126-18.15 18.15v.01c0 10.024 8.126 18.15 18.15 18.15h82c10.024 0 18.15-8.126 18.15-18.15v-.01c0-10.024-8.126-18.15-18.15-18.15z",
    fill: "#FED425"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M162.28 709.092v25.19M194.47 709.092v25.19M226.67 709.092v25.19",
    stroke: "#F79253",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M846.41 708.681c22.09 0 40-17.91 40-40v-50.24c0-33.08-26.92-60-60-60H732.9c-22.09 0-40 17.91-40 40s17.91 40 40 40h73.51v30.24c0 22.09 17.91 40 40 40z",
    fill: "#2C848E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M886.41 668.681v-50.24c0-33.08-26.92-60-60-60h-39.15",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M825.24 777.751h42.34c27.78 0 50.3-22.52 50.3-50.3 0-27.78-22.52-50.3-50.3-50.3h-42.34c-27.78 0-50.3 22.52-50.3 50.3 0 27.78 22.52 50.3 50.3 50.3z",
    fill: "#FED425"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M805.4 684.911h82c10.024 0 18.15-8.126 18.15-18.15v-.01c0-10.024-8.126-18.15-18.15-18.15h-82c-10.024 0-18.15 8.126-18.15 18.15v.01c0 10.024 8.126 18.15 18.15 18.15z",
    fill: "#FED425"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M878.6 709.092v25.19M846.41 709.092v25.19M814.21 709.092v25.19",
    stroke: "#F79253",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M749.21 455.081v321.65c0 62.9-48.41 114.51-110 119.58-3.29.28-6.63.42-10 .42H411.68c-3.37 0-6.71-.14-10-.42-61.6-5.07-110-56.68-110-119.58v-321.65c0-126.34 102.42-228.76 228.76-228.76 63.17 0 120.36 25.6 161.76 67 41.4 41.4 67.01 98.59 67.01 161.76z",
    fill: "#2C848E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M708.39 324.661a229.861 229.861 0 00-26.19-31.34c-41.4-41.4-98.59-67-161.76-67-77.86 0-146.63 38.91-187.95 98.34h375.9z",
    fill: "#036D79"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M600.13 341.481c-31.99.16-60.61 14.77-79.69 37.62-19.07-22.85-47.7-37.46-79.69-37.62-57.74-.28-104.99 47.9-104.99 105.65v48.08c0 34.25 16.57 64.71 42.12 83.77 15.3 11.42 23.84 29.63 23.79 48.72v153.43c0 41.75 33.85 75.6 75.6 75.6h86.33c41.75 0 75.6-33.85 75.6-75.6v-151.77c0-.55 0-1.1-.01-1.65-.26-19.14 8.55-37.34 23.88-48.8 25.5-19.07 42.04-49.49 42.04-83.71v-48.08c0-57.74-47.24-105.93-104.99-105.65l.01.01z",
    fill: "#27B7BE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M430.07 567.792c0 22.38-11.38 42.15-28.67 53.82-1.57-16.82-9.84-32.43-23.51-42.63-21.95-16.37-37.27-41.16-41.15-69.53 8.59-4.21 18.24-6.57 28.43-6.57 35.79 0 64.9 29.12 64.9 64.91zM704.15 509.422c-3.88 28.36-19.17 53.12-41.08 69.5-13.67 10.21-22.15 25.8-23.65 42.61-17.22-11.68-28.55-31.41-28.55-53.74 0-35.79 29.11-64.91 64.9-64.91 10.17 0 19.8 2.35 28.38 6.54z",
    fill: "#27B7BE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M291.68 715.201v61.53c0 62.9 48.4 114.51 110 119.58 3.29.28 6.63.42 10 .42h217.53c3.37 0 6.71-.14 10-.42 61.59-5.07 110-56.68 110-119.58v-61.53H291.68z",
    fill: "#58BB5F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M487.44 836.521h-66.02v60.21h66.02v-60.21zM355.4 882.741v-46.21h-47.79c11.25 19.54 27.84 35.61 47.79 46.21zM733.26 836.521h-47.79v46.21a120.623 120.623 0 0047.79-46.21zM355.41 715.201h-63.73v60.21h63.73v-60.21zM619.47 836.521h-66.02v60.21h66.02v-60.21zM487.44 715.201h-66.02v60.21h66.02v-60.21z",
    fill: "#83C883"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M553.44 775.411h-66.01v61.11h66.01v-61.11zM421.42 775.411H355.4v61.11h66.02v-61.11zM619.47 715.201h-66.02v60.21h66.02v-60.21zM749.21 715.201h-63.73v60.21h63.73v-60.21z",
    fill: "#83C883"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M685.47 775.411h-66.01v61.11h66.01v-61.11z",
    fill: "#83C883"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M749.21 715.201H291.68",
    stroke: "#1E9562",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M638.108 181.699c12.261 12.261 12.261 32.173 0 44.434l-66.065 66.065c-12.262 12.262-32.174 12.262-44.435 0l-22.217-22.217 88.275-88.275c12.261-12.261 32.173-12.261 44.435 0l.007-.007z",
    fill: "#2C848E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M581.574 163.077c12.261 12.261 12.261 32.173 0 44.434l-66.065 66.065c-12.261 12.261-32.173 12.261-44.435 0l-22.217-22.217 88.275-88.275c12.262-12.261 32.174-12.261 44.435 0l.007-.007z",
    fill: "#2C848E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M537.15 163.081c12.22-12.22 32.21-12.22 44.43 0 12.22 12.22 12.22 32.21 0 44.43l-50.92 50.92",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M435.38 354.042l-7.46 12.93c-2.16 3.73.54 8.4 4.85 8.4h14.93c4.31 0 7.01-4.67 4.85-8.4l-7.46-12.93c-2.16-3.73-7.54-3.73-9.7 0h-.01zM595.8 354.042l-7.46 12.93c-2.16 3.73.54 8.4 4.85 8.4h14.93c4.31 0 7.01-4.67 4.85-8.4l-7.46-12.93c-2.16-3.73-7.54-3.73-9.7 0h-.01z",
    fill: "#F05360"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M691.22 463.721l-12.93-7.46c-3.73-2.16-8.4.54-8.4 4.85v14.93c0 4.31 4.67 7.01 8.4 4.85l12.93-7.46c3.73-2.16 3.73-7.54 0-9.7v-.01zM349.66 463.721l12.93-7.46c3.73-2.16 8.4.54 8.4 4.85v14.93c0 4.31-4.67 7.01-8.4 4.85l-12.93-7.46c-3.73-2.16-3.73-7.54 0-9.7v-.01z",
    fill: "#EF3A48"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M440.24 386.481h-.01c-32.839 0-59.46 26.622-59.46 59.46v49.27c0 32.839 26.621 59.46 59.46 59.46h.01c32.839 0 59.46-26.621 59.46-59.46v-49.27c0-32.838-26.621-59.46-59.46-59.46z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M430.07 567.792c0 22.38-11.38 42.15-28.67 53.82-1.57-16.82-9.84-32.43-23.51-42.63-21.95-16.37-37.27-41.16-41.15-69.53 8.59-4.21 18.24-6.57 28.43-6.57 35.79 0 64.9 29.12 64.9 64.91z",
    fill: "#27B7BE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M445.23 524.671c-16.25 0-29.46-13.22-29.46-29.46v-49.26c0-16.25 13.22-29.46 29.46-29.46 16.24 0 29.46 13.22 29.46 29.46v49.26c0 16.25-13.22 29.46-29.46 29.46z",
    fill: "#044548"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M455.28 474.041l19.44 11.22c2.67 1.54 6-.38 6-3.46v-22.45c0-3.08-3.33-5-6-3.46l-19.44 11.22c-2.67 1.54-2.67 5.39 0 6.93zM600.66 386.481h-.01c-32.839 0-59.46 26.622-59.46 59.46v49.27c0 32.839 26.621 59.46 59.46 59.46h.01c32.839 0 59.46-26.621 59.46-59.46v-49.27c0-32.838-26.621-59.46-59.46-59.46z",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M704.15 509.422c-3.88 28.36-19.17 53.12-41.08 69.5-13.67 10.21-22.15 25.8-23.65 42.61-17.22-11.68-28.55-31.41-28.55-53.74 0-35.79 29.11-64.91 64.9-64.91 10.17 0 19.8 2.35 28.38 6.54z",
    fill: "#27B7BE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M595.65 524.671c-16.25 0-29.46-13.22-29.46-29.46v-49.26c0-16.25 13.22-29.46 29.46-29.46 16.24 0 29.46 13.22 29.46 29.46v49.26c0 16.25-13.22 29.46-29.46 29.46z",
    fill: "#044548"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M585.6 474.041l-19.44 11.22c-2.67 1.54-6-.38-6-3.46v-22.45c0-3.08 3.33-5 6-3.46l19.44 11.22c2.67 1.54 2.67 5.39 0 6.93z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M494.78 499.711h51.71c15.7 0 28.45 12.75 28.45 28.45v50.72c0 29.97-24.33 54.3-54.3 54.3s-54.3-24.33-54.3-54.3v-50.72c0-15.7 12.75-28.45 28.45-28.45h-.01z",
    fill: "#F79253"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M520.63 613.171c-18.91 0-34.3-15.39-34.3-34.3v-50.72c0-4.58 3.87-8.45 8.45-8.45h51.71c4.58 0 8.45 3.87 8.45 8.45v50.72c0 18.91-15.39 34.3-34.3 34.3h-.01z",
    fill: "#F05360"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M305.12 295.731v64.51c13.38-1.07 76.46-9.03 91.66-64.51h-91.66zM735.76 295.731v64.51c-13.38-1.07-76.46-9.03-91.66-64.51h91.66z",
    fill: "#EF3A48"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M365.17 502.871c35.79 0 64.9 29.12 64.9 64.91M675.71 502.871c-35.79 0-64.9 29.12-64.9 64.91",
    stroke: "#009AA9",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M650.07 827.541c18.524 0 33.54-15.016 33.54-33.54s-15.016-33.54-33.54-33.54-33.54 15.016-33.54 33.54 15.016 33.54 33.54 33.54z",
    fill: "#FED425"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M616.53 794.001c0 18.52 15.02 33.54 33.54 33.54s33.54-15.02 33.54-33.54",
    stroke: "#F79253",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M390.81 827.541c18.524 0 33.54-15.016 33.54-33.54s-15.016-33.54-33.54-33.54-33.54 15.016-33.54 33.54 15.016 33.54 33.54 33.54z",
    fill: "#FED425"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M424.35 794.001c0 18.52-15.02 33.54-33.54 33.54s-33.54-15.02-33.54-33.54",
    stroke: "#F79253",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M622.84 786.411c29.2 20.84 69.74-.04 69.74-35.91v-122.08c0-35.87-40.54-56.75-69.74-35.91l-89.04 63.54c-22.94 16.37-22.94 50.45 0 66.82l89.04 63.54z",
    fill: "#EF3A48"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M418.04 786.411c-29.2 20.84-69.74-.04-69.74-35.91v-122.08c0-35.87 40.54-56.75 69.74-35.91l89.04 63.54c22.94 16.37 22.94 50.45 0 66.82l-89.04 63.54z",
    fill: "#EF3A48"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M433.05 689.451h174.78",
    stroke: "#B62A35",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M530.81 666.361h-20.75c-7.025 0-12.72 5.695-12.72 12.72v20.75c0 7.025 5.695 12.72 12.72 12.72h20.75c7.025 0 12.72-5.695 12.72-12.72v-20.75c0-7.025-5.695-12.72-12.72-12.72z",
    fill: "#EF3A48"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M530.82 666.361c7.02 0 12.72 5.69 12.72 12.72v20.76c0 7.02-5.69 12.72-12.72 12.72h-20.76c-7.02 0-12.72-5.69-12.72-12.72v-20.76c0-7.02 5.69-12.72 12.72-12.72h20.76zm0-16h-20.76c-15.84 0-28.72 12.88-28.72 28.72v20.76c0 15.84 12.88 28.72 28.72 28.72h20.76c15.84 0 28.72-12.88 28.72-28.72v-20.76c0-15.84-12.88-28.72-28.72-28.72z",
    fill: "#B62A35"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M445.23 449.102a9.59 9.59 0 009.59-9.59 9.59 9.59 0 00-9.59-9.59 9.59 9.59 0 00-9.59 9.59c0 5.296 4.294 9.59 9.59 9.59zM595.65 449.102c5.296 0 9.59-4.294 9.59-9.59a9.59 9.59 0 00-9.59-9.59 9.59 9.59 0 00-9.59 9.59c0 5.296 4.294 9.59 9.59 9.59z",
    fill: "#fff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M670.6 268.021v-55.1c0-62.07-50.78-112.85-112.85-112.85h-83.32c-62.07 0-112.85 50.78-112.85 112.85v55.1H670.6z",
    fill: "#044548"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M664.06 175.181c-15.62-43.66-57.47-75.11-106.32-75.11h-83.32c-48.85 0-90.7 31.46-106.32 75.11",
    stroke: "#092937",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M653.77 148.182c-40.37 0-73.09 32.73-73.09 73.09v9.4",
    stroke: "#1E9562",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M641.206 105.871c-8.212-8.213-21.528-8.213-29.741 0-8.212 8.212-8.212 21.528 0 29.741l54.865 54.864c8.213 8.213 21.528 8.213 29.741 0 8.212-8.213 8.212-21.528 0-29.741l-54.865-54.864z",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M696.071 135.618c8.213-8.213 8.213-21.528 0-29.741-8.212-8.212-21.528-8.212-29.741 0l-54.864 54.865c-8.213 8.212-8.213 21.528 0 29.741 8.213 8.212 21.528 8.212 29.741 0l54.864-54.865z",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M653.77 177.652c16.276 0 29.47-13.194 29.47-29.47 0-16.276-13.194-29.47-29.47-29.47-16.276 0-29.47 13.194-29.47 29.47 0 16.276 13.194 29.47 29.47 29.47z",
    fill: "#FED425"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M653.77 177.652c16.276 0 29.47-13.194 29.47-29.47 0-16.276-13.194-29.47-29.47-29.47-16.276 0-29.47 13.194-29.47 29.47 0 16.276 13.194 29.47 29.47 29.47z",
    stroke: "#F79253",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M669.63 211.062H362.56a3 3 0 00-3 3v51.3a3 3 0 003 3h307.07a3 3 0 003-3v-51.3a3 3 0 00-3-3z",
    fill: "#1E9562"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M439.1 214.062v51.3c0 1.66.66 3 1.48 3h151.04c.81 0 1.48-1.34 1.48-3v-51.3c0-1.66-.66-3-1.48-3H440.58c-.81 0-1.48 1.34-1.48 3z",
    fill: "#58BB5F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M710.65 258.481H330.23c-11.394 0-20.63 9.237-20.63 20.63 0 11.394 9.236 20.63 20.63 20.63h380.42c11.394 0 20.63-9.236 20.63-20.63 0-11.393-9.236-20.63-20.63-20.63z",
    fill: "#044548"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M333 258.481h374.88",
    stroke: "#092937",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M483.15 515.582a97.364 97.364 0 0078.48 0",
    stroke: "#FED425",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAprilFool);
export default ForwardRef;